import { WebLayout } from 'components/Layout';
import { motion } from 'framer-motion';
import WorkshopImage from 'assets/workshop.png';
import CraftImage from 'assets/landing/newest/three.png';
import PeopleImage from 'assets/workshop.png';
import { useAboutData } from '../api/getAboutData';

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

export function AboutUs() {
  const { data: about, isLoading: aboutLoading } = useAboutData();

  return (
    <WebLayout>
      {/* ===== Hero Section ===== */}
      <section
        className="relative h-[60vh] flex items-center justify-center bg-center bg-cover text-white"
        style={{ backgroundImage: `url(${about?.data?.pageHeader?.backgroundImage})` }}
      >
        <div className="absolute inset-0 bg-black/60"></div>
        <motion.div
          className="relative z-10 text-center px-4"
          variants={fadeUp}
          initial="hidden"
          animate="visible"
        >
          <h1 className="text-3xl sm:text-7xl font-semibold mb-3  just-me-again-down-here-regular">
            {about?.data?.pageHeader?.title}
          </h1>
          <p className="text-sm sm:text-base max-w-xl mx-auto text-gray-200">
            {about?.data?.pageHeader?.caption}
          </p>
        </motion.div>
      </section>

      {/* ===== Our Story ===== */}
      <section className="bg-[#FFF6F2] py-20 px-6 sm:px-12 lg:px-24">
        <motion.div
          className="max-w-4xl mx-auto text-left"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <h2 className="text-3xl sm:text-5xl font-semibold text-[#AC3F1E] mb-6  just-me-again-down-here-regular">
            Our Story
          </h2>
          {about?.data?.ourStory?.paragraphs.map((paragraph) => (
            <p className="text-gray-700 text-sm sm:text-base leading-relaxed mb-6">{paragraph}</p>
          ))}
        </motion.div>

        {/* === Image Split === */}
        <motion.div
          className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-10 max-w-6xl mx-auto"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <img
            src={about?.data?.builtWithIntention?.image}
            alt={about?.data?.builtWithIntention?.header}
            className="w-full h-80 object-cover shadow-md"
          />
          <div className="flex flex-col justify-center">
            <h3 className="text-4xl font-semibold text-[#AC3F1E] mb-3  just-me-again-down-here-regular">
              {about?.data?.builtWithIntention?.header}
            </h3>
            <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
              {about?.data?.builtWithIntention?.caption}
            </p>
          </div>
        </motion.div>
      </section>

      {/* ===== Philosophy Section ===== */}
      <section className="bg-white py-20 px-6 sm:px-12 lg:px-24">
        <motion.div
          className="max-w-4xl mx-auto text-center"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <h2 className="text-2xl sm:text-5xl font-semibold text-[#AC3F1E] mb-4  just-me-again-down-here-regular">
            {about?.data?.philosophy?.header}
          </h2>
          <p className="text-gray-700 text-sm sm:text-base leading-relaxed mb-10">
            {about?.data?.philosophy?.content}
          </p>
        </motion.div>

        <motion.div
          className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {about?.data?.philosophy?.columns?.map((column, index) => (
            <div className="bg-[#FFF6F2] p-8 text-left shadow-md hover:shadow-lg transition">
              <h4 className="text-lg font-semibold text-[#AC3F1E] mb-2">{column?.title}</h4>
              <p className="text-sm text-gray-700">{column?.content}</p>
            </div>
          ))}
        </motion.div>
      </section>

      {/* ===== People Section ===== */}
      <section
        className="relative h-[70vh] bg-center bg-cover flex items-center justify-center text-white"
        style={{ backgroundImage: `url(${about?.data?.team?.backgroundImage})` }}
      >
        <div className="absolute inset-0 bg-black/60"></div>
        <motion.div
          className="relative z-10 text-center max-w-2xl px-4"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <h2 className="text-2xl sm:text-6xl font-semibold mb-4  just-me-again-down-here-regular">
            {about?.data?.team?.title}
          </h2>
          <p className="text-gray-200 text-sm sm:text-base">{about?.data?.team?.caption}</p>
        </motion.div>
      </section>
    </WebLayout>
  );
}
